import React from "react";

const Analytics = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h2>Analytics</h2>

      {/* Iframe to display the external page */}
      <iframe
        src="https://data.livauto.com/email-stats"
        title="Email Spam Remover"
        width="100%"
        height="800"
        style={{
          border: "1px solid #ccc",
          borderRadius: "8px",
        }}
      ></iframe>
    </div>
  );
};

export default Analytics;
